/* unplugin-vue-components disabled */import script from "./YtbHome.vue?vue&type=script&setup=true&lang=js"
export * from "./YtbHome.vue?vue&type=script&setup=true&lang=js"

import "./YtbHome.vue?vue&type=style&index=0&id=2c9fa1a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9fa1a2"]])

export default __exports__